import { useSelector } from 'react-redux';
import { useFindCurrentCountryRuleQuery } from '../api';
import { selectShippingCity, selectShippingCountry, selectShippingGeoCode, selectShippingState } from '../slices/shipping';
import useShippingPostalCodeIsValidOnClient from './useShippingPostalCodeIsValidOnClient';

/**
 * Return whether or not the shipping form is ready to be submitted
 */
const useShippingCanSubmit = () => {
    const city = useSelector(selectShippingCity);
    const country = useSelector(selectShippingCountry);
    const geoCode = useSelector(selectShippingGeoCode);
    const state = useSelector(selectShippingState);
    const postalCodeIsValidOnClient = useShippingPostalCodeIsValidOnClient();

    const countryRulesQuery = useFindCurrentCountryRuleQuery();

    return (
        country &&
        (
            !countryRulesQuery.data?.countryWithStates ||
            state
        ) &&
        postalCodeIsValidOnClient &&
        countryRulesQuery.isSuccess && (
            countryRulesQuery.data.geoCodeRequired ?
                geoCode?.geoCode :
                city
        )
    );
}

export default useShippingCanSubmit;
